import { render } from "./App.vue?vue&type=template&id=2a64f6a3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2a64f6a3&lang=css"
script.render = render

export default script